<template>
  <CheckerCapture v-if="checker.step.value === 'capture'" :variant="variant" />
  <CheckerEmpty v-else-if="checker.step.value === 'empty'" :variant="variant" />
  <template v-else-if="results">
    <CheckerResults
      v-if="checker.step.value === 'list'"
      :variant="variant"
      :results="results"
    />
    <template v-else-if="finding">
      <CheckerMatch
        v-if="checker.step.value === 'match'"
        :variant="variant"
        :finding="finding"
        :results="results"
      />
      <CheckerConfirm
        v-else-if="checker.step.value === 'confirm'"
        :variant="variant"
        :finding="finding"
        :results="results"
      />
      <CheckerDetails
        v-else-if="checker.step.value === 'details'"
        :variant="variant"
      />
    </template>
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import CheckerCapture from './CheckerCapture.vue'
import CheckerConfirm from './CheckerConfirm.vue'
import CheckerDetails from './CheckerDetails.vue'
import CheckerEmpty from './CheckerEmpty.vue'
import CheckerMatch from './CheckerMatch.vue'
import CheckerResults from './CheckerResults.vue'
import { useChecker } from './useChecker'

defineProps<{ variant: 'modal' | 'sheet' }>()

const checker = useChecker()
const results = computed(() => checker.results.value)
const finding = computed(() => checker.selected.value)
</script>
